import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=6c0a4730&scoped=true"
import script from "./Pane.vue?vue&type=script&lang=js"
export * from "./Pane.vue?vue&type=script&lang=js"
import style0 from "./Pane.vue?vue&type=style&index=0&id=6c0a4730&prod&lang=scss"
import style1 from "./Pane.vue?vue&type=style&index=1&id=6c0a4730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a4730",
  null
  
)

export default component.exports